// firebase.js
import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";


// import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAaCz7ljVyaPYnOxEckRjC7NJfuBKlMf98",
  authDomain: "evalndt-4c0ea.firebaseapp.com",
  projectId: "evalndt-4c0ea",
  storageBucket: "evalndt-4c0ea.firebasestorage.app",
  messagingSenderId: "729500959032",
  appId: "1:729500959032:web:4d247e95caba95cd3cc1cd"
};
// Check if app is already initialized to prevent "App already exists" errors
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// --- Secondary Instance (For Provisioning Operators) ---
const secondaryApp = getApps().find(a => a.name === "Secondary") 
  || initializeApp(firebaseConfig, "Secondary");
const secondaryAuth = getAuth(secondaryApp);

// --- Standard Exports ---
export { 
  auth, 
  secondaryAuth, 
  db, 
  storage, 
  collection, 
  addDoc, 
  ref, 
  uploadBytes, 
  getDownloadURL, 
  firebaseConfig 
};
// Export auth and db for use in other parts of the app
// export const db = getFirestore(app);
